module.exports = __webpack_public_path__ + "img/mp4.dde8b5da.svg";